export const setGridSelectedState = (state, action): any => {
  const updatedState = {
    ...state,
    GridSelected: action.payload.GridSelected,
  };

  return updatedState;
};
